import axios from "axios";
import {MEDIA_API} from "../config/config";

export const downloadFile = (uuid) => {
    return axios({
        url: `${MEDIA_API}/${uuid}`,
        method: 'get',
        responseType: "blob"
    })
}